import React, { useEffect, useState } from 'react'
import { Link } from 'react-router-dom'
import axios from 'axios'
import './PricePlans.css'

const peso = (n) =>
  typeof n === 'number'
    ? n.toLocaleString('es-MX', { style: 'currency', currency: 'MXN' })
    : `$${n}`

    

const PlanCard = ({ plan, highlight }) => {
  const yearly = plan.frequency_type?.toLowerCase() === 'year'
  const priceStr = peso(plan.price)
  const freqLabel = `Cobro ${yearly ? 'anual' : 'mensual'} de ${priceStr} recurrente`
  const btnText = plan?.metadata?.buttonText || 'Suscríbete al plan'

  return (
    <article
      className={`lp-plan ${highlight ? 'lp-plan--highlight' : ''} ${yearly ? 'lp-plan--yearly' : ''}`}
    >
      {/* Badge */}
      {yearly && <span className="lp-pill">Más Popular</span>}

      {/* Media */}
      <div className="lp-plan__media">
        {plan.image ? (
          <img className="lp-plan__thumb" src={plan.image} alt={plan.name} />
        ) : (
          <div className="lp-plan__thumb lp-plan__thumb--icon" aria-hidden>🌿</div>
        )}
      </div>

      {/* Title & frequency */}
      <header className="lp-plan__head">
        <h3 className="lp-plan__title">{plan.name}</h3>
        <div className="lp-plan__freq">
          {yearly ? 'anual' : 'mensual'} <span className="lp-flag">🇲🇽</span>
        </div>
      </header>

      {/* Price */}
      <div className="lp-plan__price">
        <div className="lp-plan__amount">{priceStr}</div>
        <div className="lp-plan__caption">{freqLabel}</div>
      </div>

      {/* Features */}
      {!!plan.features?.length && (
        <ul className="lp-plan__features">
          {plan.features.map((f, i) => (
            <li key={i} className="included"> {f.name} </li>
          ))}
        </ul>
      )}

      {/* CTA */}
      <Link to={{ pathname: '/log-in', search: '?redirect=/payment-methods' }} className="lp-btn lp-btn--primary">
        {btnText}
      </Link>
    </article>
  )
}

const PricePlans = () => {
  const [plans, setPlans] = useState([])
  const [loading, setLoading] = useState(true)

  useEffect(() => {
    const fetchPlans = async () => {
      try {
        const { data } = await axios.get(
          `${process.env.REACT_APP_BASE_URL}/api/subscription_plan/`,
          { timeout: 7000 }
        )
        setPlans(Array.isArray(data) ? data : [])
      } catch (e) {
        console.error('Error fetching prices', e)
      } finally {
        setLoading(false)
      }
    }
    fetchPlans()
  }, [])

  if (loading) return <p style={{ textAlign: 'center' }}>Cargando precios…</p>

  // highlight the yearly plan if present
  const yearlyId = plans.find(p => p.frequency_type?.toLowerCase() === 'year')?.id

  return (
    <section className="lp">
      <div className="lp__title">Elige tu plan</div>

      <div className="lp-grid">
        {plans.map(plan => (
          <PlanCard
            key={plan.id || plan.stripe_price_id || plan.name}
            plan={plan}
            highlight={plan.id === yearlyId}
          />
        ))}
      </div>
    </section>
  )
}

export default PricePlans
